module.exports = __webpack_public_path__ + "img/Images.f2e31c5b.svg";